import canUseDom from 'app/utilities/dom';

const env = canUseDom() ? window.__ENV__ : process.env;

const {
    API_BASE_URL,
    CLIENT_ID,
    CLIENT_SECRET,
    NODE_ENV,
    APP_ENV,
    SENTRY_DSN,
    APP_PORT,
    GOOGLE_TAG_MANAGER_CONTAINER_ID,
    GOOGLE_SITE_VERIFICATION,
    RECAPTCHA_KEY,
    RECAPTCHA_V3_KEY,
    MAPPEDIN_ID,
    MAPPEDIN_KEY,
    MAPPEDIN_WESTERN_SPRINGS_ID,
    MAPPEDIN_WESTERN_SPRINGS_KEY,
} = env;

// Don't expose any of the following: CLIENT_ID, CLIENT_SECRET
export const clientEnv = {
    API_BASE_URL: '/api',
    NODE_ENV,
    APP_ENV,
    SENTRY_DSN,
    APP_PORT,
    GOOGLE_TAG_MANAGER_CONTAINER_ID,
    GOOGLE_SITE_VERIFICATION,
    RECAPTCHA_KEY,
    RECAPTCHA_V3_KEY,
    MAPPEDIN_ID,
    MAPPEDIN_KEY,
    MAPPEDIN_WESTERN_SPRINGS_ID,
    MAPPEDIN_WESTERN_SPRINGS_KEY,
};

export default {
    API_BASE_URL,
    CLIENT_ID,
    CLIENT_SECRET,
    NODE_ENV,
    APP_ENV,
    SENTRY_DSN,
    APP_PORT,
    GOOGLE_TAG_MANAGER_CONTAINER_ID,
    GOOGLE_SITE_VERIFICATION,
};

export const isProd = env.NODE_ENV === 'production';
export const isAppProd = env.APP_ENV === 'prod';
